var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "navbar navbar-expand-lg navbar-dark fixed-top" },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "a",
          {
            staticClass: "navbar-brand",
            attrs: { href: "#" },
            on: { click: _vm.navigateToHome },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/images/logo.png"),
                alt: "39游戏盒子",
                height: "40",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mobile-nav-controls d-flex align-items-center" },
          [
            _c("div", {
              staticClass: "download-btn-img",
              on: { click: _vm.handleDownload },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "navbar-toggler custom-toggler",
                class: { collapsed: !_vm.isMenuOpen },
                attrs: { type: "button", "aria-expanded": _vm.isMenuOpen },
                on: { click: _vm.toggleMobileMenu },
              },
              [
                _c("img", {
                  staticClass: "toggler-icon-open",
                  attrs: {
                    src: require("@/assets/images/zss.png"),
                    alt: "菜单",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "toggler-icon-close" }, [
                  _vm._v("×"),
                ]),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "mobile-menu navbar-collapse",
            class: { show: _vm.isMenuOpen },
          },
          [
            _c("div", { staticClass: "container" }, [
              _c("ul", { staticClass: "navbar-nav" }, [
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.currentSection === "home" },
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          return _vm.navigateToSection("home")
                        },
                      },
                    },
                    [_vm._v("\n              首页\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          return _vm.navigateToSection("web")
                        },
                      },
                    },
                    [_vm._v("\n              网页版\n            ")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.currentSection === "changelog" },
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          return _vm.navigateToSection("changelog")
                        },
                      },
                    },
                    [_vm._v("\n              更新日志\n            ")]
                  ),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("a", {
          staticClass: "download-btn-img d-none d-lg-block ms-auto",
          attrs: {
            href: "https://bbsnewapi.3975bbs.com/common/packageAppLink?advertisingId=350",
            target: "_blank",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }